export default {
  createTitle: 'Новый товар',
  detailTitle: 'Товар',
  listTitle: 'Каталог товаров',
  homeLink: 'Добавить товар',
  empty: 'Товары не найдены',
  columns: {
    id: 'ID',
    image: 'Фото',
    title: 'Название',
    subtitle: 'Подзаголовок',
    restaurant: 'Ресторан',
    category: 'Раздел ресторана',
    price: 'Цена',
    weightG: 'Вес (г)',
    isAvailable: 'Акт.',
    createdAt: 'Создан',
    updatedAt: 'Изменён',
    details: 'Подробно',
  },
  values: {
    available: 'Да',
    unavailable: 'Нет',
  },
  filters: {
    title: 'Фильтры',
    productId: 'ID товара',
    productIdPlaceholder: 'ID товара',
    restaurantId: 'ID ресторана',
    restaurantIdPlaceholder: 'Ресторан',
    categoryTitle: 'Раздел ресторана',
    categoryTitlePlaceholder: 'Раздел ресторана',
    productTitle: 'Название',
    productTitlePlaceholder: 'Название',
    apply: 'Применить',
    reset: 'Сбросить',
  },
  fields: {
    restaurant: 'Ресторан',
    product: 'Блюдо',
    productEmpty: 'Выберите блюдо',
    category: 'Раздел меню',
    categoryEmpty: 'Без категории',
    tags: 'Метки блюда',
    tagsPlaceholder: 'Выберите метки',
    title: 'Название',
    subtitle: 'Подзаголовок',
    description: 'Описание',
    price: 'Цена (VND)',
    weightG: 'Вес (г)',
    isAvailable: 'Доступен в каталоге',
    imageFiles: 'Изображения',
    imageUrls: 'Ссылки на изображения',
    imageUrlPlaceholder: 'https://…',
  },
  imageFiles: {
    add: 'Загрузить изображение',
    remove: 'Удалить',
    previewAlt: 'Превью',
    uploading: 'Загрузка…',
    uploadFailed: 'Не удалось загрузить файл',
    itemLabel: 'Изображение {index}',
  },
  imageUrls: {
    add: 'Добавить ссылку',
    remove: 'Удалить',
    previewAlt: 'Превью',
  },
  productTags: {
    spicy: 'Острое',
    recommended: 'Рекомендуем',
    hit: 'Хит',
  },
  categoryDialog: {
    title: 'Новая категория',
    nameLabel: 'Название раздела',
    save: 'Создать',
    saving: 'Создание…',
    cancel: 'Отмена',
    nameRequired: 'Введите название',
    created: 'Категория создана',
    createFailed: 'Не удалось создать категорию',
  },
  actions: {
    openDetails: 'Подробно',
    openDetailsNewWindow: 'Открыть подробнее в новом окне',
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    submit: 'Сохранить товар',
    update: 'Сохранить изменения',
    submitting: 'Сохранение…',
    delete: 'Удалить товар',
    deleting: 'Удаление…',
  },
  success: 'Товар сохранён',
  updateSuccess: 'Изменения сохранены',
  deleteSuccess: 'Товар удалён',
  deleteConfirm: 'Удалить товар «{title}»? Это действие нельзя отменить.',
  errors: {
    loadList: 'Не удалось загрузить список товаров',
  },
  modifiers: {
    variant: {
      label: 'Варианты выбора',
      hint: 'Одна группа: порция, острота и т.п. Обязательно отметьте вариант по умолчанию.',
      template: 'Шаблон группы',
      templatePlaceholder: 'Выбрать из существующих',
      groupTitle: 'Название группы',
      groupTitlePlaceholder: 'Например, Выберите порцию',
      optionTitlePlaceholder: 'Например, 10 шт.',
      pricePlaceholder: 'Доплата',
      isDefault: 'По умолчанию',
      addOption: 'Добавить вариант',
      removeOption: 'Удалить вариант',
    },
    toppings: {
      label: 'Дополнения',
      templatePlaceholder: 'Выбрать из существующих',
      add: 'Добавить дополнение',
      remove: 'Удалить дополнение',
      namePlaceholder: 'Например, сыр',
      pricePlaceholder: 'Доплата',
    },
    validation: {
      slug: 'Некорректный идентификатор опции',
      groupTitle: 'Введите заголовок группы',
      optionTitle: 'Введите название опции',
      priceDelta: 'Доплата — целое число ≥ 0',
      optionsMin: 'Добавьте хотя бы одну опцию',
      optionsMax: 'Не больше 20 опций в группе',
      groupsMax: 'Не больше 10 групп',
      defaultRequired: 'Выберите один вариант по умолчанию',
    },
  },
  validation: {
    restoRequired: 'Выберите ресторан',
    productRequired: 'Выберите блюдо',
    titleRequired: 'Введите название',
    priceRequired: 'Введите цену',
    priceInteger: 'Цена должна быть целым числом',
    priceMin: 'Цена не может быть отрицательной',
    weightInteger: 'Вес должен быть целым числом',
    weightRange: 'Вес от 1 до 50000 г',
    imageFilesMax: 'Не больше 5 изображений',
    imageFilesUploading: 'Дождитесь окончания загрузки изображений',
    imageFilesMissingId: 'Перезагрузите изображения перед сохранением',
    imageUrlsMax: 'Не больше 10 ссылок на изображения',
    imageUrlInvalid: 'Введите корректный URL',
  },
  apiErrors: {
    generic: 'Не удалось сохранить товар. Попробуйте снова.',
    loadFailed: 'Не удалось загрузить товар. Попробуйте снова.',
    deleteFailed: 'Не удалось удалить товар. Попробуйте снова.',
    validation_error: 'Проверьте поля формы',
    category_resto_mismatch: 'Категория относится к другому ресторану',
    category_not_found: 'Категория не найдена',
    resto_not_found: 'Ресторан не найден',
    unauthorized: 'Нужна авторизация',
    forbidden: 'Нет доступа',
  },
}
